export const localePrefix = (language?: string, country?: string) => {
  if (!country) country = process.env.NEXT_PUBLIC_COUNTRY || 'US';
  country = country.toUpperCase();

  if (!language) language = 'en';

  if (language == 'en') {
    return '';
  } else {
    return '/' + language;
  }
};

export const localeSpecificPath = (path: string, language?: string, country?: string) => {
  // remove any existing language / locale
  path = path.replace(/^\/[a-z]{2}(?:-[a-zA-Z]{2})*\//, '/');
  // Only do this for known redesign paths
  if (
    path == '' ||
    path == '/' ||
    path.indexOf('/account') == 0 ||
    path.indexOf('/bus-station') == 0 ||
    path.indexOf('/bus-routes') == 0 ||
    path.indexOf('/purchase') == 0 ||
    path.indexOf('/schedules') == 0
  ) {
    // add correct lang and locale
    let pathWithLocale = localePrefix(language, country) + path;
    /*
     * Some exceptions.  Perhaps can be done w/o exceptions with some refactoring
     *
     */
    // Homepage
    if (pathWithLocale == '/' || pathWithLocale == '') {
      return '';
    }
    // /es, /fr
    if (path == '') {
      pathWithLocale += '/';
    }
    // End exceptions

    return pathWithLocale;
  }
  return path;
};
